module.exports = __webpack_public_path__ + "static/media/icon-plus2.2017d45c.svg";